export default [
  {
    path: '/sessions',
    name: 'session',
    meta: { requiresAuth: true },
    component: () => import('@/pages/session/index.vue'),
  }
]
